<template>
  <article class="kpi-card" :class="'is-' + level">
    <div class="kpi-bar"></div>
    <div class="kpi-body">
      <div class="kpi-title">
        <i class="kpi-dot"></i>
        <span>{{ title }}</span>
      </div>
      <slot>
        <div class="kpi-value">{{ value }}<span v-if="unit && value !== '—'" class="kpi-unit">{{ unit }}</span></div>
      </slot>
      <div class="kpi-period-row">
        <span class="kpi-period">{{ period }}</span>
        <span v-if="compare" class="kpi-compare" :class="'is-' + compareTone">{{ compare }}</span>
      </div>
      <p class="kpi-foot">{{ foot }}</p>
    </div>
  </article>
</template>
<script>
export default {
  name: 'KpiCard',
  props: {
    level: { type: String, default: 'healthy' },
    title: { type: String, default: '' },
    value: { type: [String, Number], default: '—' },
    unit: { type: String, default: '' },
    period: { type: String, default: '' },
    compare: { type: String, default: '' },
    compareTone: { type: String, default: 'neutral' },
    foot: { type: String, default: '' }
  }
}
</script>
<style scoped lang="less">
@import './vars.less';

.kpi-card {
  position: relative;
  display: flex;
  min-height: 200px;
  background: @card;
  border-radius: @radius-card;
  box-shadow: @card-shadow;
  overflow: hidden;
}

.kpi-bar {
  width: 4px;
  flex-shrink: 0;
  background: #D8DEE8;
}

.kpi-card.is-danger .kpi-bar,
.kpi-card.is-danger .kpi-dot {
  background: @danger;
}

.kpi-card.is-warning .kpi-bar,
.kpi-card.is-warning .kpi-dot {
  background: @warning;
}

.kpi-card.is-healthy .kpi-bar,
.kpi-card.is-healthy .kpi-dot {
  background: @healthy;
}

.kpi-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  padding: 16px 18px 14px;
}

.kpi-title {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 1.4;
  color: @text-title;
}

.kpi-dot {
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background: #D8DEE8;
}

.kpi-value {
  margin-top: 18px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.2;
  color: @text;
  white-space: nowrap;
}

.kpi-unit {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 500;
  color: @text-muted;
}

.kpi-period-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
  font-size: 12px;
  line-height: 1.5;
  color: @text-muted;
}

.kpi-period {
  min-width: 0;
  flex: 1 1 auto;
}

.kpi-compare {
  flex-shrink: 0;
  font-weight: 600;
  white-space: nowrap;
  color: @text-muted;
  &.is-danger {
    color: @danger;
  }
  &.is-warning {
    color: @warning;
  }
  &.is-healthy {
    color: @healthy;
  }
}

.kpi-foot {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid @line-soft;
  font-size: 12px;
  line-height: 1.5;
  color: @text-desc;
}
</style>



// WEBPACK FOOTER //
// KpiCard.vue?3ea41946